export const getFact = (state: any) => state.fact;
export const getFactContent = (state: any) => getFact(state).get('content');
export const isLoaded = (state: any) => getFact(state).get('isLoaded');
export const isOpen = (state: any) => getFact(state).get('isOpen');
export const tries = (state: any) => getFact(state).get('tries');